import React from 'react'

    // Define relationship mappings based on sex
    export const getRelationshipBasedOnSex=(type,sex)=> {
      const sexBasedRelationships={
        // Siblings
        'sibling': {'male': 'brother','female': 'sister','other': 'sibling'},
        // Spouse
        'spouse': {'male': 'husband','female': 'wife','other': 'spouse'},
        // Ex-spouse
        'ex_spouse': {'male': 'ex-husband','female': 'ex-wife','other': 'ex-spouse'},
        // Parent
        'parent': {'male': 'father','female': 'mother','other': 'parent'},
        // Child
        'child': {'male': 'son','female': 'daughter','other': 'child'},
        // Grandparent
        'grandparent': {'male': 'grandfather','female': 'grandmother','other': 'grandparent'},
        // Grandchild
        'grandchild': {'male': 'grandson','female': 'granddaughter','other': 'grandchild'},
        // Great-grandparent and beyond
        'great_grandparent': {'male': 'great-grandfather','female': 'great-grandmother','other': 'great-grandparent'},
        'great_great_grandparent': {'male': 'great-great-grandfather','female': 'great-great-grandmother','other': 'great-great-grandparent'},
        // Aunt/Uncle
        'parental_sibling': {'male': 'uncle','female': 'aunt','other': 'parent\'s sibling'},
        // Niece/Nephew
        'sibling_child': {'male': 'nephew','female': 'niece','other': 'sibling\'s child'},
        // Grandniece/Grandnephew
        'grandsibling_child': {'male': 'grandnephew','female': 'grandniece','other': 'grandniece/grandnephew'},
        // In-laws
        'sibling_in_law': {'male': 'brother-in-law','female': 'sister-in-law','other': 'sibling-in-law'},
        'parent_in_law': {'male': 'father-in-law','female': 'mother-in-law','other': 'parent-in-law'},
        'child_in_law': {'male': 'son-in-law','female': 'daughter-in-law','other': 'child-in-law'},
        'sibling_child_in_law': {'male': 'nephew-in-law','female': 'niece-in-law','other': 'sibling\'s child-in-law'},
        'parental_sibling_in_law': {'male': 'uncle-in-law','female': 'aunt-in-law','other': 'parent\'s sibling-in-law'},
        // Partner (new)
        'partner': {'male': 'male partner','female': 'female partner','other': 'partner'},
        // Cousin (new)
        'cousin': {'male': 'male cousin','female': 'female cousin','other': 'cousin'},
        // 2nd Cousin (new)
        'second_cousin': {'male': 'male 2nd cousin','female': 'female 2nd cousin','other': '2nd cousin'},
        // 3rd Cousin (new)
        'third_cousin': {'male': 'male 3rd cousin','female': 'female 3rd cousin','other': '3rd cousin'},
        // Removed cousins
        'first_cousin_once_removed': {'male': 'male 1st cousin once removed','female': 'female 1st cousin once removed','other': '1st cousin once removed'},
        'first_cousin_twice_removed': {'male': 'male 1st cousin twice removed','female': 'female 1st cousin twice removed','other': '1st cousin twice removed'},
        'second_cousin_once_removed': {'male': 'male 2nd cousin once removed','female': 'female 2nd cousin once removed','other': '2nd cousin once removed'},
        // Extended family
        'grandparent_sibling': {'male': 'great-uncle','female': 'great-aunt','other': 'great-aunt/uncle'},
        // Step/half relationships
        'step_parent': {'male': 'stepfather','female': 'stepmother','other': 'step-parent'},
        'step_child': {'male': 'stepson','female': 'stepdaughter','other': 'step-child'},
        'step_sibling': {'male': 'stepbrother','female': 'stepsister','other': 'step-sibling'},
        'half_sibling': {'male': 'half-brother','female': 'half-sister','other': 'half-sibling'},
        // Adoptive relationships
        'adoptive_parent': {'male': 'adoptive father','female': 'adoptive mother','other': 'adoptive parent'},
        'adoptive_child': {'male': 'adoptive son','female': 'adoptive daughter','other': 'adoptive child'},
        // Cousin-in-law (informal)
        'cousin_in_law': {'male': 'male cousin-in-law','female': 'female cousin-in-law','other': 'cousin-in-law'}
      }

      // Return the specific relationship based on sex,or the original type if not found
      return sexBasedRelationships[type]?.[sex] || type
    }

    // Get the opposite relationship type with correct perspective handling
    export const getOppositeRelationship=(relationship,sex)=> {
      // CRITICAL FIX: Correct relationship mappings to prevent parent/sibling confusion
      const oppositeMap={
        // Base types to base types - FIXED RELATIONSHIPS
        'sibling': 'sibling',
        'spouse': 'spouse',
        'ex_spouse': 'ex_spouse',
        'parent': 'child',// Parent -> Child (CORRECT)
        'child': 'parent',// Child -> Parent (CORRECT)
        'grandparent': 'grandchild',
        'grandchild': 'grandparent',
        'great_grandparent': 'great_grandchild',
        'great_grandchild': 'great_grandparent',
        'great_great_grandparent': 'great_great_grandchild',
        'great_great_grandchild': 'great_great_grandparent',
        'parental_sibling': 'sibling_child',// Aunt/Uncle -> Niece/Nephew
        'sibling_child': 'parental_sibling',// Niece/Nephew -> Aunt/Uncle
        'grandsibling_child': 'grandparent_sibling',// Grandniece/Nephew -> Great-aunt/uncle
        'grandparent_sibling': 'grandsibling_child',// Great-aunt/uncle -> Grandniece/nephew
        'sibling_in_law': 'sibling_in_law',// Brother-in-law/Sister-in-law (symmetric)
        'parent_in_law': 'child_in_law',// Parent-in-law -> Child-in-law
        'child_in_law': 'parent_in_law',// Child-in-law -> Parent-in-law
        'sibling_child_in_law': 'parental_sibling_in_law', // niece/nephew-in-law -> aunt/uncle-in-law
        'parental_sibling_in_law': 'sibling_child_in_law', // aunt/uncle-in-law -> niece/nephew-in-law
        'friend': 'friend',
        'colleague': 'colleague',
        'boss': 'employee',
        'employee': 'boss',
        'partner': 'partner',// Partner -> Partner (symmetric)
        'cousin': 'cousin',// Cousin -> Cousin (symmetric)
        'second_cousin': 'second_cousin',// 2nd Cousin -> 2nd Cousin (symmetric)
        'third_cousin': 'third_cousin',// 3rd Cousin -> 3rd Cousin (symmetric)
        'first_cousin_once_removed': 'first_cousin_once_removed',
        'first_cousin_twice_removed': 'first_cousin_twice_removed',
        'second_cousin_once_removed': 'second_cousin_once_removed',
        // Step/half relationships
        'step_parent': 'step_child',
        'step_child': 'step_parent',
        'step_sibling': 'step_sibling',
        'half_sibling': 'half_sibling',
        // Adoptive relationships
        'adoptive_parent': 'adoptive_child',
        'adoptive_child': 'adoptive_parent',
        // Cousin-in-law
        'cousin_in_law': 'cousin_in_law',

        // Specific types - handle reverse mapping properly
        'brother': 'sibling',
        'sister': 'sibling',
        'husband': 'spouse',
        'wife': 'spouse',
        'ex-husband': 'ex_spouse',
        'ex-wife': 'ex_spouse',
        'father': 'child',// Father -> Child (CORRECT)
        'mother': 'child',// Mother -> Child (CORRECT)
        'son': 'parent',// Son -> Parent (CORRECT)
        'daughter': 'parent',// Daughter -> Parent (CORRECT)
        'grandfather': 'grandchild',
        'grandmother': 'grandchild',
        'grandson': 'grandparent',
        'granddaughter': 'grandparent',
        'great-grandfather': 'great_grandchild',
        'great-grandmother': 'great_grandchild',
        'great_great_grandfather': 'great_great_grandchild',
        'great_great_grandmother': 'great_great_grandchild',
        'uncle': 'sibling_child',// Uncle -> Nephew/Niece (CORRECT)
        'aunt': 'sibling_child',// Aunt -> Nephew/Niece (CORRECT)
        'nephew': 'parental_sibling',// Nephew -> Uncle/Aunt (CORRECT)
        'niece': 'parental_sibling',// Niece -> Uncle/Aunt (CORRECT)
        'grandnephew': 'grandparent_sibling',
        'grandniece': 'grandparent_sibling',
        'great-uncle': 'grandsibling_child',
        'great-aunt': 'grandsibling_child',
        'brother-in-law': 'sibling_in_law',
        'sister-in-law': 'sibling_in_law',
        'father-in-law': 'child_in_law',
        'mother-in-law': 'child_in_law',
        'son-in-law': 'parent_in_law',
        'daughter-in-law': 'parent_in_law',
        'nephew-in-law': 'parental_sibling_in_law',
        'niece-in-law': 'parental_sibling_in_law',
        'uncle-in-law': 'sibling_child_in_law',
        'aunt-in-law': 'sibling_child_in_law',
        'male partner': 'partner',
        'female partner': 'partner',
        'male cousin': 'cousin',
        'female cousin': 'cousin',
        'male 2nd cousin': 'second_cousin',
        'female 2nd cousin': 'second_cousin',
        'male 3rd cousin': 'third_cousin',
        'female 3rd cousin': 'third_cousin',
        'male 1st cousin once removed': 'first_cousin_once_removed',
        'female 1st cousin once removed': 'first_cousin_once_removed',
        'male 1st cousin twice removed': 'first_cousin_twice_removed',
        'female 1st cousin twice removed': 'first_cousin_twice_removed',
        'male 2nd cousin once removed': 'second_cousin_once_removed',
        'female 2nd cousin once removed': 'second_cousin_once_removed',
        // Step/half relationships
        'stepfather': 'step_child',
        'stepmother': 'step_child',
        'stepson': 'step_parent',
        'stepdaughter': 'step_parent',
        'stepbrother': 'step_sibling',
        'stepsister': 'step_sibling',
        'half-brother': 'half_sibling',
        'half-sister': 'half_sibling',
        // Adoptive relationships
        'adoptive father': 'adoptive_child',
        'adoptive mother': 'adoptive_child',
        'adoptive son': 'adoptive_parent',
        'adoptive daughter': 'adoptive_parent',
        // Cousin-in-law
        'male cousin-in-law': 'cousin_in_law',
        'female cousin-in-law': 'cousin_in_law'
      }
      // First get the base opposite type
      const baseType=oppositeMap[relationship] || relationship
      // Then convert to sex-specific if needed
      return sex ? getRelationshipBasedOnSex(baseType,sex) : baseType
    }

    // Helper function to get the base relationship type from specific types
    export const getBaseRelationshipType=(specificType)=> {
      const typeMap={
        'brother': 'sibling',
        'sister': 'sibling',
        'husband': 'spouse',
        'wife': 'spouse',
        'ex-husband': 'ex_spouse',
        'ex-wife': 'ex_spouse',
        'father': 'parent',
        'mother': 'parent',
        'son': 'child',
        'daughter': 'child',
        'grandfather': 'grandparent',
        'grandmother': 'grandparent',
        'grandson': 'grandchild',
        'granddaughter': 'grandchild',
        'great-grandfather': 'great_grandparent',
        'great-grandmother': 'great_grandparent',
        'great_great-grandfather': 'great_great_grandparent',
        'great_great-grandmother': 'great_great_grandparent',
        'uncle': 'parental_sibling',
        'aunt': 'parental_sibling',
        'nephew': 'sibling_child',// FIXED: nephew -> sibling_child
        'niece': 'sibling_child',// FIXED: niece -> sibling_child
        'grandnephew': 'grandsibling_child',
        'grandniece': 'grandsibling_child',
        'great-uncle': 'grandparent_sibling',
        'great-aunt': 'grandparent_sibling',
        'brother-in-law': 'sibling_in_law',
        'sister-in-law': 'sibling_in_law',
        'father-in-law': 'parent_in_law',
        'mother-in-law': 'parent_in_law',
        'son-in-law': 'child_in_law',
        'daughter-in-law': 'child_in_law',
        'nephew-in-law': 'sibling_child_in_law',
        'niece-in-law': 'sibling_child_in_law',
        'uncle-in-law': 'parental_sibling_in_law',
        'aunt-in-law': 'parental_sibling_in_law',
        'male partner': 'partner',
        'female partner': 'partner',
        'male cousin': 'cousin',
        'female cousin': 'cousin',
        'male 2nd cousin': 'second_cousin',
        'female 2nd cousin': 'second_cousin',
        'male 3rd cousin': 'third_cousin',
        'female 3rd cousin': 'third_cousin',
        'male 1st cousin once removed': 'first_cousin_once_removed',
        'female 1st cousin once removed': 'first_cousin_once_removed',
        'male 1st cousin twice removed': 'first_cousin_twice_removed',
        'female 1st cousin twice removed': 'first_cousin_twice_removed',
        'male 2nd cousin once removed': 'second_cousin_once_removed',
        'female 2nd cousin once removed': 'second_cousin_once_removed',
        // Step/half relationships
        'stepfather': 'step_parent',
        'stepmother': 'step_parent',
        'stepson': 'step_child',
        'stepdaughter': 'step_child',
        'stepbrother': 'step_sibling',
        'stepsister': 'step_sibling',
        'half-brother': 'half_sibling',
        'half-sister': 'half_sibling',
        // Adoptive relationships
        'adoptive father': 'adoptive_parent',
        'adoptive mother': 'adoptive_parent',
        'adoptive son': 'adoptive_child',
        'adoptive daughter': 'adoptive_child',
        // Cousin-in-law
        'male cousin-in-law': 'cousin_in_law',
        'female cousin-in-law': 'cousin_in_law'
      }
      return typeMap[specificType] || specificType
    }

    // FIXED: Get relationship from correct perspective
    export const getRelationshipFromPerspective=(relationshipType,personASex,personBSex,isPersonAPerspective)=> {
      if (isPersonAPerspective) {
        // Person A's perspective: what is person B to person A?
        // First get the base opposite type
        const baseOppositeType=getOppositeRelationship(relationshipType,null)
        // Then apply person B's sex
        return getRelationshipBasedOnSex(baseOppositeType,personBSex)
      } else {
        // Person B's perspective: what is person A to person B?
        return getRelationshipBasedOnSex(relationshipType,personASex)
      }
    }